import { NOTIFICATION_SUPPORT } from 'src/services/notification';
import { dayjs } from 'src/services/date';

export default () => ({
  getAllRequestId: null,
  isLoadingAllNotifications: false,
  lastWebNotificationHash: null,
  sinceDate: dayjs()
    .utc()
    .subtract(2, 'day'),
  notifications: [],
  notificationSupport: NOTIFICATION_SUPPORT.UNKNOWN,
});
